// Compliance Reviews: the routes and the sidebar rows of `wealth.compliance.reviews` (ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const ComplianceReviewsCard = lazy(() =>
    import('./reviews.slots').then((m) => ({ default: m.ComplianceReviewsCard })),
);

export default defineWebFeature({
    id: 'wealth.compliance.reviews',
    slots: {
        // SEP-334. The reviews that wait for the Compliance decision, on the Comply Dashboard.
        'comply.dashboard.cards': [
            {
                key: 'reviews',
                order: 10,
                title: 'Suitability reviews to decide',
                summary: 'The suitability reviews that wait for a Compliance decision.',
                span: 6,
                rows: 5,
                // The card reads its queue in its own hook, so the page cannot
                // know the count. The card thus never collapses and never
                // raises the hidden cue (SEP-296).
                count: () => null,
                emptyBehaviour: 'keep',
                Component: ComplianceReviewsCard,
            },
        ],
    },
    routes: [
        {
            frontend: 'comply',
            path: 'cmp-reviews',
            lazy: () => import('@/pages/comply/cmp-reviews/page'),
        },
        {
            frontend: 'comply',
            path: 'suitability-reviews',
            lazy: () => import('@/pages/comply/suitability-reviews/page'),
        },
    ],
    nav: [
        // SEP-243 sections 31, 34 and 41 - the Compliance review work queue. It
        // holds each Internal Review that waits for a Compliance decision, and each
        // one that waits for a peer reviewer.
        {
            frontend: 'comply',
            key: 'suitability-reviews',
            label: 'Compliance Reviews',
            href: '/comply/suitability-reviews',
            icon: 'UserCheck',
            group: 'consumer-duty',
            order: 230,
        },
        {
            frontend: 'comply',
            key: 'cmp-reviews',
            label: 'CMP Reviews',
            href: '/comply/cmp-reviews',
            icon: 'ClipboardCheck',
            group: 'monitoring',
            order: 410,
            wip: true,
        },
    ],
});
